/**
 * CandidateAvatar — Funcionalidade 1 (Fase 1)
 *
 * Renders the official TSE photo when available for the candidate slug;
 * falls back to a party-coloured circle with the candidate initials when
 * the photo endpoint returns 404 or errors.
 */
import React, { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const PARTY_HEX = {
  PT: "#CC0000", PSDB: "#0058A8", PL: "#003366", MDB: "#FAC828", PSOL: "#FFC72C",
  PSB: "#FF6600", REPUBLICANOS: "#008060", PODEMOS: "#00A8E0", PP: "#186CA8",
  PDT: "#CC3300", "UNIÃO": "#0066CC", NOVO: "#FFA500", "PCdoB": "#CC0000",
  REDE: "#008060", PV: "#00A860", AVANTE: "#FF8000", SOLIDARIEDADE: "#F08028",
  CIDADANIA: "#0060A8",
};

const partyColor = (party) => {
  if (!party) return "#64748B";
  const match = party.match(/\(([^)]+)\)/);
  const acro = (match?.[1] || party).toUpperCase().trim();
  return PARTY_HEX[acro] || "#64748B";
};

const initials = (name) => {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "??";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export function CandidateAvatar({ slug, name, party, size = 80, className = "" }) {
  const [photo, setPhoto] = useState(null);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!slug) return undefined;
    fetch(`${BACKEND}/api/public/candidatos/${slug}/foto`)
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => { if (!cancelled) setPhoto(json?.url || null); })
      .catch(() => { if (!cancelled) setPhoto(null); });
    return () => { cancelled = true; };
  }, [slug]);

  const boxStyle = { width: size, height: size };
  const showPhoto = photo && !errored;

  return (
    <div
      className={`rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center ${className}`}
      style={boxStyle}
      data-testid={`candidate-avatar-${slug || "unknown"}`}
    >
      {showPhoto ? (
        <img
          src={photo}
          alt={name || "Candidato"}
          className="w-full h-full object-cover"
          onError={() => setErrored(true)}
          loading="lazy"
        />
      ) : (
        <div
          className="w-full h-full flex items-center justify-center text-white font-bold"
          style={{ backgroundColor: partyColor(party), fontSize: size * 0.36 }}
          aria-hidden="true"
        >
          {initials(name)}
        </div>
      )}
    </div>
  );
}

export default CandidateAvatar;
